import { render, staticRenderFns } from "./currentYear.vue?vue&type=template&id=35f9bc35&"
import script from "./currentYear.vue?vue&type=script&lang=js&"
export * from "./currentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports